$(function () {
  const header = document.querySelector('.header');
  const headerHeight = header.offsetHeight;
  const handleScroll = () => {
    if (window.scrollY > headerHeight) {
      header.classList.add('is-stuck');
      header.classList.remove('is-not-stuck');
    } else {
      header.classList.remove('is-stuck');
      header.classList.add('is-not-stuck');
    }
  };

  window.addEventListener('scroll', e => {
    handleScroll();
  });
});
//# sourceMappingURL=cica-clic-navigation-bar.js.map
